// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Student} from '../../core/_models'

type Props = {
  row: Row<Student>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-150px': cell.column.id === 'actions'})}
          style={{
            position: cell.column.id === 'actions' || cell.column.id === 'statusName' ? 'sticky' : 'unset',
            right: cell.column.id === 'actions' ? 0 : cell.column.id === 'statusName' ? '100px' : 'unset',
            background: row.index % 2 !== 0 ? 'white' : '#F3F7F9',
            borderLeft: cell.column.id === 'statusName' ? 'solid 1px rgba(0, 0, 0, 0.2)' : 'unset',
          }}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
